import * as echarts from 'echarts';
var option = {
    title: {
        text: "按故障统计",
        top: 8,
        left: 8,
        textStyle: {
            color: "#ffffff"
        }

    },
    grid: {
        left: '12%',
        top: '15%',
        bottom: '12%',
        right: '8%'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    xAxis: {
        data: [],
        axisTick: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(255, 129, 109,.1)',
                width: 1 //这里是为了突出显示加上的
            }
        },
        axisLabel: {
            textStyle: {
                color: '#ffffff',
                fontSize: 12
            }
        }
    },
    yAxis: [{
        axisTick: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 //这里是为了突出显示加上的
            }
        },
        axisLabel: {
            textStyle: {
                color: '#ffffff'
            }
        },
        splitArea: {
            areaStyle: {
                color: 'rgba(255,255,255,.5)'
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
            }
        }
    }
    ],
    series: [

    ]
};

option.configItem = function () {
    return {
        name: '',
        type: 'bar',
        stack: '故障',
        barWidth: 20,
        itemStyle: {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(55,255,249,1)"
            },
            {
                offset: 1,
                color: "rgba(0,222,215,0.2)"
            }
            ])
        },
        data: []
    };
}

option.configColor = function () {
    return [
        {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(55,255,249,1)"
            },
            {
                offset: 1,
                color: "rgba(0,222,215,0.2)"
            }
            ])
        },
        {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(255,252,0,1)"
            },
            {
                offset: 1,
                color: "rgba(8,228,222,0.2)"
            }
            ])
        },

    ]
}

export default option;